// @ts-nocheck
import { Braces } from 'lucide-react';
import { Section, useNode } from '../ui';
import { FlattenSectionsContext } from '../../../builder-components/CollapsibleSection';
import DataVariablesSection from '../../../builder-components/DataVariablesSection';

export default function VariablesSection({ next, onNext, value, onChange }) {
  const node = useNode('variables');
  return (
    <Section
      id="variables"
      icon={Braces}
      title="Data variables"
      sub="Details the agent collects or receives during a call."
      tag={node.ok ? (value?.length ? 'set' : 'done') : 'optional'}
      ok={node.ok}
      next={next('variables')}
      onNext={onNext}
    >
      <FlattenSectionsContext.Provider value>
        <DataVariablesSection value={value} onChange={onChange} />
      </FlattenSectionsContext.Provider>
    </Section>
  );
}
